import { Box } from "../../../../../../mads";

import React, { type PropsWithChildren } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export const WithSafeAreaInsetsTopMargin: React.FC<PropsWithChildren<{ disabled?: boolean }>> = ({
  children,
  disabled,
}) => {
  const { bottom: extraButtonPadding } = useSafeAreaInsets();

  return <Box sx={{ marginTop: disabled ? 0 : -extraButtonPadding }}>{children}</Box>;
};
